import { RecaptchaBadge, Honeypot } from '@ccg/core';
import React$1, { useRef, useState, useEffect } from 'react';
import { objectWithoutProperties as _objectWithoutProperties, extends as _extends, objectSpread2 as _objectSpread2 } from '../../_virtual/_rollupPluginBabelHelpers.js';
import PropTypes$1 from 'prop-types';
import Button$1 from '../../basics/Button/Button.js';
import Text$1 from '../../basics/Text/Text.js';
import Link$1 from '../../basics/Link/Link.js';
import Radio$1 from '../../basics/Radio/Radio.js';
import Input$1 from '../../basics/Input/Input.js';
import Upload$1 from '../../basics/Upload/Upload.js';
import Checkbox$1 from '../../basics/Checkbox/Checkbox.js';
import Select$1 from '../../basics/Select/Select.js';
import Textarea$1 from '../../basics/Textarea/Textarea.js';
import StyledForm from './Form.style.js';

const validateEmail = value => /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(value);
const FormInput = props => {
  const {
    type
  } = props,
        rest = _objectWithoutProperties(props, ["type"]);

  switch (type) {
    case 'text':
      return /*#__PURE__*/React$1.createElement(Input$1, rest);

    case 'email':
      return /*#__PURE__*/React$1.createElement(Input$1, _extends({
        type: "email"
      }, rest));

    case 'select':
      return /*#__PURE__*/React$1.createElement(Select$1, rest);

    case 'checkbox':
      return /*#__PURE__*/React$1.createElement(Checkbox$1, rest);

    case 'radio':
      return /*#__PURE__*/React$1.createElement(Radio$1, rest);

    case 'textarea':
      return /*#__PURE__*/React$1.createElement(Textarea$1, rest);

    case 'upload':
      return /*#__PURE__*/React$1.createElement(Upload$1, rest);

    case 'paragraph':
      return /*#__PURE__*/React$1.createElement(Text$1, _extends({}, rest, {
        className: "form__text"
      }));

    case 'honeypot':
      return /*#__PURE__*/React$1.createElement(Honeypot, rest);

    case 'recaptcha':
      return /*#__PURE__*/React$1.createElement(RecaptchaBadge, rest);

    default:
      return /*#__PURE__*/React$1.createElement(Input$1, rest);
  }
};
FormInput.propTypes = {
  type: PropTypes$1.string
};
FormInput.defaultProps = {
  type: ''
};
const FormErrors = ({
  error
}) => {
  return /*#__PURE__*/React$1.createElement(React$1.Fragment, null, /*#__PURE__*/React$1.createElement("p", null, error.length, "Errors"));
};
FormErrors.propTypes = {
  error: PropTypes$1.arrayOf(PropTypes$1.shape)
};
FormErrors.defaultProps = {
  error: []
};

const Form = (_ref) => {
  let {
    initialFormData,
    formId,
    onSuccess,
    onError,
    className,
    submitUrl,
    submitLabel,
    formToggle,
    linkTo,
    hasGrid
  } = _ref,
      props = _objectWithoutProperties(_ref, ["initialFormData", "formId", "onSuccess", "onError", "className", "submitUrl", "submitLabel", "formToggle", "linkTo", "hasGrid"]);

  const formRef = useRef(null);
  const recaptchaRef = useRef(null);
  const [formState, setFormState] = useState(null);
  const [formMessage, setFormMessage] = useState(null);
  const [formData, setFormData] = useState(initialFormData);
  const [toggledForm, setToggledForm] = useState(formToggle === null);

  const fetchCsrfToken = async () => {
    return fetch('/api/ccg/forms/csrf', {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      }
    }).then(res => res.json()).then(json => {
      return json.token;
    });
  };

  useEffect(() => {
    setToggledForm(formToggle === null);
  }, [formToggle]);
  useEffect(() => {
    if (formState === 'success') {
      // const successData = arrayToObject(formData, 'id');
      // onSuccess(successData);
      // const { top } = formRef.current.getBoundingClientRect();
      // window.scrollTo({ top, left: 0, behavior: 'smooth' });
      window.dataLayer.push({
        event: 'form_success',
        formLocation: `form_${formId}`
      });
      recaptchaRef.current.reset();
      formRef.current.reset();
      formRef.current.querySelectorAll('textarea').forEach(e => {
        e.value = '';
      });
      setFormData(initialFormData);
    } else if (formState === 'error') {
      onError(formData.filter(item => item.error).map(({
        label,
        errorMessage
      }) => ({
        label,
        errorMessage
      })));
    }
  }, [formState]);

  const handleRecaptcha = value => {
    if (formState === 'error') setFormState(null);
    setFormData(prev => prev.map(item => item.id === `recaptcha-${formId}` ? _objectSpread2(_objectSpread2({}, item), {}, {
      value,
      error: value === ''
    }) : item));
  };

  const handleChange = e => {
    if (formState === 'error') setFormState(null);
    let success = false;
    const {
      value,
      name,
      type,
      checked,
      files
    } = e.target;

    if (type === 'file') {
      setFormData(prev => prev.map(item => item.id === name ? _objectSpread2(_objectSpread2({}, item), {}, {
        files
      }) : item));
    } else if (type === 'checkbox') {
      setFormData(prev => prev.map(item => item.id === name ? _objectSpread2(_objectSpread2({}, item), {}, {
        error: false,
        checked,
        value
      }) : item));
    } else {
      if (type === 'email') {
        success = validateEmail(value);
      } else {
        success = value !== '';
      }

      setFormData(prev => prev.map(item => item.id === name ? _objectSpread2(_objectSpread2({}, item), {}, {
        success,
        value
      }) : item));
    }
  };

  const handleFocus = e => {
    const {
      name
    } = e.target;
    setFormData(prev => prev.map(item => item.id === name ? _objectSpread2(_objectSpread2({}, item), {}, {
      error: false
    }) : item));
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setFormState(null);
    setFormMessage(null);
    const inputElements = Array.from(formRef.current.querySelectorAll('input, select, textarea, .form__recaptcha'));
    let isValid = true;
    await inputElements.forEach(element => {
      let valid = true;
      let errorMessage = '';
      const obj = formData.filter(item => item.id === element.name || item.id === element.id);

      if (element.type === 'email') {
        valid = validateEmail(element.value);
        errorMessage = 'Geben sie eine gültige Email ein';
      } else if (element.type === 'checkbox' && obj[0] && obj[0].required) {
        valid = element.checked;
        errorMessage = 'Dieses Feld ist verpflichtend';
      } else if (element.type === 'file' && obj[0] && obj[0].required) {
        valid = element.files.length;
        errorMessage = 'Dieses Feld ist verpflichtend';
      } else if (obj[0] && obj[0].type === 'recaptcha') {
        valid = obj[0].value !== '';
        errorMessage = 'Dieses Feld ist verpflichtend';
      } else if (obj[0] && obj[0].required) {
        valid = element.value !== '' && element.validity.valid;
        errorMessage = element.validity.patternMismatch ? 'Der Wert ist im falschen Format' : 'Dieses Feld ist verpflichtend';
      }

      if (!valid) {
        setFormData(prev => prev.map(item => item.id === element.name || item.id === element.id ? _objectSpread2(_objectSpread2({}, item), {}, {
          errorMessage,
          error: true
        }) : item));
      }

      isValid = isValid && valid;
    });

    if (isValid) {
      setFormMessage('sending...');
      const csrfToken = await fetchCsrfToken();

      if (!submitUrl) {
        formRef.current.submit();
      } else {
        // generate a formData obeject (automatically sets content-type to multipart/form-data)
        const submitData = new FormData(); // push form id into submitData

        submitData.append('id', formId); // push formData into submitData

        formData.forEach(fieldData => {
          if (fieldData.type === 'upload' && fieldData.files) {
            if (fieldData.files.length > 1) {
              const documentsFieldName = fieldData.id.includes('[]') ? fieldData.id : `${fieldData.id}[]`;

              for (let i = 0; i < fieldData.files.length; i += 1) {
                submitData.append(documentsFieldName, fieldData.files.item(i));
              }
            } else {
              submitData.append(fieldData.id, fieldData.files.item(0));
            }
          } else if (fieldData.type === 'checkbox') {
            if (fieldData.checked) {
              submitData.append(fieldData.id, fieldData.value);
            }
          } else if (fieldData.type !== 'paragraph' && fieldData.value) {
            submitData.append(fieldData.id, fieldData.value);
          } else if (fieldData.type === 'recaptcha' && fieldData.value) {
            submitData.append(fieldData.id, fieldData.value);
          }
        });
        fetch(submitUrl, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'X-CSRF-Token': csrfToken
          },
          body: submitData
        }).then(res => res.json()).then(json => {
          // TODO set form messages for Craft Form
          if (json.state === 'success') {
            setFormState('success');
            setFormMessage(json.message);
          } else if (json.state === 'error') {
            setFormState('error');
            setFormMessage(json.message);
          }
        }).catch(() => {
          setFormState('error');
          setFormMessage('Sorry, something went wrong');
        });
      }

      setFormState('success');
    } else {
      setFormState('error');
    }
  };

  return /*#__PURE__*/React$1.createElement(StyledForm, _extends({
    className: className,
    hasGrid: hasGrid
  }, props), /*#__PURE__*/React$1.createElement(React$1.Fragment, null, /*#__PURE__*/React$1.createElement("div", {
    className: "form__actions"
  }, formToggle && /*#__PURE__*/React$1.createElement(Button$1, {
    className: "form__toggle",
    variant: "primary",
    onClick: () => setToggledForm(!toggledForm)
  }, formToggle), linkTo && linkTo.url && /*#__PURE__*/React$1.createElement(Link$1, {
    className: "form__link",
    href: linkTo.url,
    title: linkTo.text,
    target: linkTo.target,
    type: "primary"
  }, linkTo.text)), toggledForm && /*#__PURE__*/React$1.createElement("form", {
    className: "form__form",
    onSubmit: handleSubmit,
    noValidate: true,
    ref: formRef,
    autoComplete: "off"
  }, formData.map(item => {
    if (item.type === 'recaptcha') {
      return /*#__PURE__*/React$1.createElement("div", {
        className: "form__input",
        key: item.id
      }, /*#__PURE__*/React$1.createElement(FormInput, _extends({
        recaptchaRef: recaptchaRef,
        className: "form__recaptcha",
        onChange: handleRecaptcha
      }, item)));
    }

    return /*#__PURE__*/React$1.createElement("div", {
      className: "form__input",
      key: item.id
    }, /*#__PURE__*/React$1.createElement(FormInput, _extends({
      onChange: handleChange,
      onFocus: handleFocus
    }, item)));
  }), /*#__PURE__*/React$1.createElement("div", {
    className: "form__messages"
  }, formState === 'error' && /*#__PURE__*/React$1.createElement(React$1.Fragment, null, formData.filter(item => item.error).map(({
    label,
    errorMessage
  }) => /*#__PURE__*/React$1.createElement("p", {
    className: "form__error-message",
    key: label
  }, `${label}: ${errorMessage}`))), formMessage && /*#__PURE__*/React$1.createElement("p", {
    className: "form__submit-message"
  }, formMessage)), /*#__PURE__*/React$1.createElement(Button$1, {
    className: "form__submit",
    type: "submit",
    variant: "primary"
  }, submitLabel || 'Submit'))));
};

Form.propTypes = {
  /**
   * Array with initial input props
   */
  initialFormData: PropTypes$1.arrayOf(PropTypes$1.shape({
    type: PropTypes$1.oneOf(['text', 'radio', 'checkbox', 'textarea', 'select', 'upload', 'paragraph', 'email'])
  })).isRequired,

  /**
   * Form id in pardot/craft
   */
  formId: PropTypes$1.number,

  /**
   * Triggers if form validation was successfull
   */
  onSuccess: PropTypes$1.func,

  /**
   * Triggers on form validation error
   */
  onError: PropTypes$1.func,

  /**
   * Additional className for form element
   */
  className: PropTypes$1.string,

  /**
   * Submit URL
   */
  submitUrl: PropTypes$1.string,

  /**
   * Submit Label
   */
  submitLabel: PropTypes$1.string,

  /**
   * Label for the form toggle
   */
  formToggle: PropTypes$1.string,

  /**
   * Link Button
   */
  linkTo: PropTypes$1.shape({
    type: PropTypes$1.string,
    text: PropTypes$1.string,
    customText: PropTypes$1.string,
    url: PropTypes$1.string,
    target: PropTypes$1.string
  }),
  hasGrid: PropTypes$1.bool
};
Form.defaultProps = {
  onSuccess: () => {},
  onError: () => {},
  className: null,
  formId: null,
  submitUrl: null,
  submitLabel: null,
  formToggle: null,
  linkTo: null,
  hasGrid: true
};

export default Form;
export { FormErrors, FormInput, validateEmail };
